import classNames from "classnames";
import classes from "./SherlockResultsChartLegend.module.css";

export default function SherlockResultsChartLegend() {
  return (
    <div className={classes.legendContainer}>
      <div className={classes.legendItem}>
        <span className={classNames(classes.icon, classes.sherlockChangeIcon)} />
        <h5 className={classes.label}>Change with Sherlock investigation</h5>
      </div>

      <div className={classes.legendItem}>
        <span className={classNames(classes.icon, classes.nonSherlockChangeIcon)} />
        <h5 className={classes.label}>Change without Sherlock investigation</h5>
      </div>
    </div>
  );
}
